



















import Vue from 'vue';
import * as Telescope from '@zyf2e/telescope';
// import { mapActions } from 'vuex';

// import { SPECIALIST, SPECIALIST_GET_CLINIC_HOME_PAGE } from '@/constant';

import { SearchBar, SearchPanel } from '@/components/SearchBox';
import {
  PAGE_EXPERT_CONSULTATION_SEARCH,
  CLICK_EXPERT_CONSULTATION_SEARCH_CANCEL,
  CLICK_EXPERT_CONSULTATION_SEARCH_CLEAR,
  CLICK_EXPERT_CONSULTATION_SEARCH_HISTORY
} from '../../../constant';

export default Vue.extend({
  name: 'searchBiz',
  components: {
    SearchBar,
    SearchPanel
  },
  props: {
    showSearch: {
      type: Boolean,
      default: () => false
    },
    historyList: {
      type: Array,
      default: () => []
    },
    value: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {};
  },

  watch: {
    value() {
      if (this.value) {
        Telescope.trackPage({ trackId: PAGE_EXPERT_CONSULTATION_SEARCH });
      }
    }
  },

  methods: {
    // ...mapActions(SPECIALIST, [SPECIALIST_GET_CLINIC_HOME_PAGE]),
    onCancel() {
      Telescope.trackEvent({ trackId: CLICK_EXPERT_CONSULTATION_SEARCH_CANCEL });
      this.$emit('onCancel');
    },
    onSearch(searchText: string) {
      this.$emit('onSearch', searchText);
    },
    onSelect(searchText: string) {
      Telescope.trackEvent({ trackId: CLICK_EXPERT_CONSULTATION_SEARCH_HISTORY });
      this.$emit('onSelect', searchText);
    },
    onDelete() {
      Telescope.trackEvent({ trackId: CLICK_EXPERT_CONSULTATION_SEARCH_CLEAR });
      this.$emit('onDelete');
    }
  }
});
